import type { DeleteSurveyParams, Survey } from 'app/common/types/surveys'
import type { Request } from '../../../index'
import { convertSurvey, SurveyDto } from '../common'

export const convertParams = ({ surveyId }: DeleteSurveyParams) =>
  [undefined, { id: surveyId }] as [void, { id: string }]
export const convertResult = (data: { survey: SurveyDto }): Survey => convertSurvey(data.survey)
export const RESTORE_SURVEY: Request<DeleteSurveyParams, Survey, { id: string }> = [
  'food/surveys/{id}/restore',
  'put',
  ['data'],
]
